import React from "react";

const Play = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M30.411 18.88L7.667 33.823a1.083 1.083 0 01-1.514-.337A1.046 1.046 0 016 32.943V3.057c0-.191.053-.38.153-.543.1-.164.242-.299.413-.389a1.086 1.086 0 011.101.052L30.411 17.12a1.046 1.046 0 010 1.76z"
          fill={fill}
      />
    </svg>
);

export default Play;